import { http } from "@/utilities";

const controller = process.env.VUE_APP_API_ZIARAT + "auth/";

export default {
  verify: (params) => http.getByParams(`${controller}verify`, params),
};
